import React from 'react'

export const TestTab = () => {
  return (
    <iframe src={`${window.location.origin}/inside-iframe`}>
    </iframe>
  )
}
